/* eslint-disable newline-per-chained-call */
import TooltipWrapper from "components/CandidateProfile/TooltipWrapper";
import React from "react";

interface EducationListProps {
  education_experience: any;
  showAll?: boolean;
  isSmall?: boolean;
}

const EducationComponent: React.FC<EducationListProps> = ({
  education_experience,
  showAll = false,
  isSmall = false,
}) => {
  const EducationExperiences = education_experience || [];
  const displayedExperiences = showAll ? EducationExperiences : EducationExperiences.slice(0, 2);

  const getEducationsToolTip = (edu: any) => {
    const item = edu;

    if (item) {
      if (item?.modified_date) {
        const date = new Date(item?.modified_date).toISOString().split("T")[0];
        return `${item.is_edited ? "Edited" : "Added"} by ${item.edited_by} on ${date}`;
      }
      return;
    }
    return;
  };

  return (
    <ul className={`list-disc pl-5 ${isSmall ? "text-xs" : ""}`}>
      {displayedExperiences.map((education: any, index: number) =>
        education.edited_by !== "" ? (
          <li className="text-text-heading mb-2" key={index}>
            <TooltipWrapper text={getEducationsToolTip(education)!} placement="right" key={index}>
              <div className="flex items-center gap-1.5 flex-wrap">
                {education?.degree &&
                  education?.degree !== "NA" &&
                  education?.field &&
                  education?.field !== "NA" && (
                    <>
                      <p className="text-fonttext-primary font-semibold text-sm">
                        {education?.degree}
                      </p>{" "}
                      in{" "}
                      <p className="text-text-tertiary font-semibold text-sm">{education.field}</p>{" "}
                      at
                    </>
                  )}

                <p className="text-sm">{education.schoolName}</p>
                {education.start_date_formatted && education.start_date_formatted !== "NA" && (
                  <>
                    {" "}
                    <span className="text-text-heading font-semibold">
                      ({education.start_date_formatted})
                    </span>
                  </>
                )}
              </div>
            </TooltipWrapper>
          </li>
        ) : (
          <li className="text-text-heading mb-2" key={index}>
            <div className="flex items-center gap-1.5 flex-wrap">
              {education?.degree &&
                education?.degree !== "NA" &&
                education?.field &&
                education?.field !== "NA" && (
                  <>
                    <p className="text-fonttext-primary font-semibold text-sm">
                      {education?.degree}
                    </p>{" "}
                    in <p className="text-text-tertiary font-semibold text-sm">{education.field}</p>{" "}
                    at
                  </>
                )}

              <p className="text-sm">{education.schoolName}</p>
              {education.start_date_formatted && education.start_date_formatted !== "NA" && (
                <>
                  {" "}
                  <span className="text-text-heading font-semibold">
                    ({education.start_date_formatted})
                  </span>
                </>
              )}
            </div>
          </li>
        )
      )}
    </ul>
  );
};

export default EducationComponent;
